import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders, formAuthHeaders } from "../../utils/axios";

export const addNpaProperties = createAsyncThunk("property/addNpaProperties",async ({data}, { rejectWithValue }) => {
  try {
    const response = await Axios.post(`/api/admin/properties/add`,data,formAuthHeaders());
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const updateNpaProperties = createAsyncThunk("property/updateNpaProperties",async ({ id, data}, { rejectWithValue }) => {
  try {
    const response = await Axios.put(`/api/admin/properties/update/${id}`,data,formAuthHeaders());
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const deleteAllProperty = createAsyncThunk("properties/deleteProperty",async({id},{ rejectWithValue }) => {
    try{
     const response = await Axios.delete(`/broker/properties/${id}`,authHeaders());
     return response.data; //success Case
    }catch(err){
      return rejectWithValue(err.response?.data || err.message); // Error case
    }
})

export const fetchPropertyConfig = createAsyncThunk(
  "properties/fetchPropertyConfig",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get("/broker/properties/config", authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchBrokerClients = createAsyncThunk(
  "properties/fetchBrokerClients",
  async ({ user_id, search }, { rejectWithValue }) => {
    try {
      let url = `/broker/clients?user_id=${user_id}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      const response = await Axios.get(url, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createBrokerClient = createAsyncThunk(
  "properties/createBrokerClient",
  async ({ user_id, name, mobile_number, email }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `/broker/clients`,
        { user_id, name, mobile_number, email },
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadPropertyFile = createAsyncThunk(
  "properties/uploadPropertyFile",
  async ({ user_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("files", file);

      const token = localStorage.getItem("auth-token");
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      };

      const response = await Axios.post(
        `/broker/properties/files/upload?user_id=${user_id}`,
        formData,
        { headers }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePropertyFile = createAsyncThunk(
  "properties/deletePropertyFile",
  async ({ id, user_id }, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        `/broker/properties/files/${id}?user_id=${user_id}`,
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addBrokerProperty = createAsyncThunk(
  "properties/addBrokerProperty",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await Axios.post("/broker/properties", data, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateBrokerProperty = createAsyncThunk(
  "properties/updateBrokerProperty",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(`/broker/properties/${id}`, data, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const npaAllProperties = createAsyncThunk(
  "properties/npaAllProperties",
  async (
    {
      status,
      page,
      limit,
      search,
      asset_category,
      property_type,     // string | string[]
      possession_type,   // string | string[]
      city_town,
      reserve_price,
      transaction_type,  // string | string[]
      is_public,
      land_types         // string
    },
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();

      // Add parameters to query string
      if (status) queryParams.append("status", status);
      if (limit) queryParams.append("limit", limit);
      if (page) queryParams.append("page", page);
      if (search) queryParams.append("search", search);
      if (asset_category) queryParams.append("asset_category", asset_category);
      if (property_type) queryParams.append("property_type", property_type);
      if (possession_type) queryParams.append("possession", possession_type);
      if (city_town) queryParams.append("city_town", city_town);
      if (reserve_price) queryParams.append("reserve_price", reserve_price);
      if (transaction_type) queryParams.append("transaction_type", transaction_type);
      if (land_types) queryParams.append("land_types", land_types);
      
      // Only add is_public if it is true
      // if (is_public === true) {
      //   queryParams.append("is_public", true);
      // }

      // Make the API call with the dynamic query string
      const endpoint =
          is_public === true
            ? "/broker/properties/public-properties"
            : "/broker/properties";

        const response = await Axios.get(
          `${endpoint}?${queryParams.toString()}`,
          authHeaders()
        );


      return response.data; // success case
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message); // error case
    }
  }
);

export const fetchPropertyDetails = createAsyncThunk(
  "properties/fetchPropertyDetails",
  async ({ id, is_public = false }, { rejectWithValue }) => {
    try {
      const endpoint = is_public
        ? `/broker/properties/public-properties/${id}`
        : `/broker/properties/${id}`;

      const response = await Axios.get(endpoint, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPropertyStats = createAsyncThunk(
  "properties/fetchPropertyStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        "/broker/properties/stats",
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

export const reqToGetFilterData = createAsyncThunk("properties/reqToGetFilterData",async ({ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/bank/filters/metadata`,formAuthHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const importUserList = createAsyncThunk("properties/importUserList",async (data,{ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/app-users`, {
      ...authHeaders(),
      params: data,
    });
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const fetchDropdownUsers = createAsyncThunk("properties/fetchDropdownUsers", async (data, { rejectWithValue }) => {
  try {
    const response = await Axios.get(`/app-users/active`, {
      ...authHeaders(),
      params: data,
    });
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});



export const reqToImportNpaProperties = createAsyncThunk("properties/reqToImportNpaProperties",async ({data},{ rejectWithValue }) => {
  try {
    const response = await Axios.post(`/api/admin/properties/bulk-insert`,data,formAuthHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const propertyTypesDropdown = createAsyncThunk("properties/propertyTypesDropdown",async ({ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/admin/properties/dropdowns`,authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const changePublicStatus = createAsyncThunk(
  "properties/changePublicStatus",
  async ({ id, is_public }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `/broker/properties/${id}/change-public-status`,
        { is_public },
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const changeStatus = createAsyncThunk(
  "properties/changeStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `/broker/properties/${id}/change-status`,
        { status },
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const changePublicPropertyStatus = createAsyncThunk(
  "properties/changePublicPropertyStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `/broker/properties/public-properties/${id}/change-status`,
        { status },
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const archiveProperty = createAsyncThunk(
  "properties/archiveProperty",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `/broker/properties/${id}/archive`,
        {},
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const unarchiveProperty = createAsyncThunk(
  "properties/unarchiveProperty",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `/broker/properties/${id}/unarchive`,
        {},
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePublicProperty = createAsyncThunk(
  "properties/deletePublicProperty",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        `/broker/properties/public-properties/${id}`,
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addBrokerPublicProperty = createAsyncThunk(
  "properties/addBrokerPublicProperty",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        "/broker/properties/public-properties",
        data,
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateBrokerPublicProperty = createAsyncThunk(
  "properties/updateBrokerPublicProperty",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `/broker/properties/public-properties/${id}`,
        data,
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const allPropertiesSlice = createSlice({
  name: "allProperties",
  initialState: {
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    property: [],
    propertyStats: {},
    propertyDetail:{},
    filter:{},
    addProperty:{},
    updateProperty:{},
    deleteNpaProperty:{},
    importData:[],
    importBankUsers:[],
    propertyDropdown:[],
    propertyConfig: null,
    brokerClients: [],
  },
  reducers: {
    clearPropertyDetails(state) {
      state.propertyDetail = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
       // Add NPA Property
       .addCase(addNpaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
       .addCase(addNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addProperty = action.payload;
      })
      .addCase(addNpaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
      // Update NPA Property
      .addCase(updateNpaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
        .addCase(updateNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateProperty = action.payload;
      })
      .addCase(updateNpaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
       // NPA Property List
       .addCase(npaAllProperties.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(npaAllProperties.fulfilled, (state, action) => {        
        state.isLoading = false;
        state.property = action.payload;
      })
      .addCase(npaAllProperties.rejected, (state, action) => {
        state.isLoading = false;
      })

      .addCase(fetchPropertyStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyStats = action.payload;
      })
      // NPA Property Details
      // .addCase(propertyDetails.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.propertyDetail = action.payload;
      // })
      // Delete NPA Property

      .addCase(fetchPropertyDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPropertyDetails.fulfilled, (state, action) => {     
        state.isLoading = false;
        state.propertyDetail = action.payload.data;
      })
      .addCase(fetchPropertyDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload; // Handle error state
      })
      .addCase(deleteAllProperty.fulfilled, (state, action) => {
        state.isLoading = false;
        const id = action.meta.arg?.id || action.meta.arg;
        const rows = state.property?.data || [];
        const index = rows.findIndex((p) => p.id === id);
        if (index !== -1) {
          rows.splice(index, 1);
        }
      })
      .addCase(deletePublicProperty.fulfilled, (state, action) => {
        state.isLoading = false;
        const id = action.meta.arg;
        const rows = state.property?.data || [];
        const index = rows.findIndex((p) => p.id === id);
        if (index !== -1) {
          rows.splice(index, 1);
        }
      })
      // request to fetch filter data
      .addCase(reqToGetFilterData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filter = action.payload;
      })
      // request to get list of Import Users
      .addCase(importUserList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.importBankUsers = action.payload;
      })
      // request to import Npa Properties
      .addCase(reqToImportNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.importData = action.payload;
      })
      // request to Types of property Dropdown
      .addCase(propertyTypesDropdown.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDropdown = action.payload;
      })
      // Status & Visibility Local Updates
      .addCase(changeStatus.fulfilled, (state, action) => {
        const { id, data } = action.payload;
        const rows = state.property?.data || [];
        const index = rows.findIndex((p) => p.id === id);
        if (index !== -1) {
          rows[index].status = data.data.status;
        }
      })
      .addCase(changePublicPropertyStatus.fulfilled, (state, action) => {
        const { id, data } = action.payload;
        const rows = state.property?.data || [];
        const index = rows.findIndex((p) => p.id === id);
        if (index !== -1) {
          rows[index].status = data.data.status;
        }
      })
      .addCase(changePublicStatus.fulfilled, (state, action) => {
        const { id, data } = action.payload;
        const updatedStatus = data.data.is_public;
        const rows = state.property?.data || [];
        
        // Find by either id or property_id (for public view)
        const index = rows.findIndex((p) => (p.id === id || p.property_id === id));
        if (index !== -1) {
          // If we are unpublishing a linked public record, remove it from the list
          if (updatedStatus === false && rows[index].property_id) {
            rows.splice(index, 1);
          } else {
            rows[index].is_public = updatedStatus;
          }
        }
      })
      .addCase(archiveProperty.fulfilled, (state, action) => {
        const { id } = action.payload;
        const rows = state.property?.data || [];
        const index = rows.findIndex((p) => p.id === id);
        if (index !== -1) {
          rows[index].is_archived = true;
        }
      })
      .addCase(unarchiveProperty.fulfilled, (state, action) => {
        const { id } = action.payload;
        const rows = state.property?.data || [];
        const index = rows.findIndex((p) => p.id === id);
        if (index !== -1) {
          rows[index].is_archived = false;
        }
      })
      .addCase(fetchPropertyConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyConfig = action.payload.data || action.payload;
      })
      .addCase(fetchBrokerClients.fulfilled, (state, action) => {
        state.isLoading = false;
        state.brokerClients = action.payload.data || action.payload;
      })
  },
});
export const { clearPropertyDetails } = allPropertiesSlice.actions;
export default allPropertiesSlice.reducer;
